// @flow
import type {
  ResetPasswordOperator,
} from '../types'

// Operator Composer
import composeOperator from 'fc-operations'

// Exports
export default function geResetOperator (): ResetPasswordOperator {
  return composeOperator({
    model: 'ResetPassword',
    branch: 'resetOperation',
  })
}
